<script lang="ts">
import SectionDelivery from '@/generated/sections/SectionDelivery.vue';
import { storeDelivery } from '@/generated/stores';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: SectionDelivery,
  mounted() {
    this.updated = true
  },
  methods: {
    readOnly(value: string): boolean {
      let res = false;
      if (!this.editDelivery.canUpdate) {
        return true;
      }
      if (this.readOnlyMap.size == 0) {
        this.readOnlyMap.set("REFERENCE", false);
        this.readOnlyMap.set("COUNT", true);
        this.readOnlyMap.set("AMOUNT", true);
      }
      const readOnly = this.readOnlyMap.get(value);
      if (readOnly != undefined) {
        res = readOnly;
      }
      return res;
    },
    sectionSave(): void {
      if (this.checkFields()) {
        storeDelivery.createDelivery(this.editDelivery).then((res) => {
          if (res) {
            this.$emit('closeDialog');
          }
        })
      }
    }
  }
})

</script>
